// src/features/counterSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { settingService } from '../services/api/setting.service';
import { walletService } from '../services/api/wallet.service';
import { transactionService } from '../services/api/transaction.service';
import { logoutAuth } from '../store/authReducer';
import { mainService } from '../services/api/main.service'
// export const getCurrentPhase = createAsyncThunk('data/fetchCurrentPhase', async (token:string) => {
//   try{
//    const phaseData = await authService.checkCurrentPhase(token);   
//     return phaseData;
//   }  catch(error) {

//   }   
// });
export const getCounterParty = createAsyncThunk('data/fetchCounterparty', async () => {
   const result = await mainService.getCounterpartiesData()

return result 
});

// export const getFiatPrices = createAsyncThunk('data/fetchFiatPrices', async () => {
//   const response = await settingService.getFiatCurrency();
//   return response;
// });
// export const getCryptoWallets = createAsyncThunk('data/fetchCryptoWallets', async () => {
//   const response = await walletService.getCryptoWallets();        
//   return response;
// });
// export const getMasterCardData = createAsyncThunk('data/fetchMasterCardData', async () => {
//   const response = await cardService.getMasterCardData();    
//   return response;
// });
// export const createCryptoWallet = createAsyncThunk('data/createCryptoWallet', async (currency:string) => {
//   const response = await walletService.createWallet(currency);   
//   return response;
// });
const initialState = {
   
    data:[],
    status:"idle"
   
  }
const counterpartySlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    // updateTicketStatus(state, data){
    //   console.log(data);
    //     state.ticketStatus.data.hasTicket = data.payload.hasTicket;
    //     state.ticketStatus.data.isCompleted = data.payload.isCompleted;
    //     state.ticketStatus.data.ticketStatus = data.payload.ticketStatus;
    //     // state.ticketStatus.status = "succeeded"
    // },
    // logout: (state) => {
    //   state.ticketStatus.data.hasTicket = false;
    //   state.ticketStatus.data.isCompleted = false;
    //   state.ticketStatus.data.ticketStatus = false;
    // },
  },
  extraReducers: (builder) => {
    builder
    //   .addCase(getTransactionHistory.pending, (state) => {
    //     state.history.status = 'loading';
    //   })
      .addCase(getCounterParty.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload.counterparties;
      })
    //   .addCase(getTransactionHistory.rejected, (state, action) => {
    //     state.history.status = 'failed';
    //   })
    //   .addCase(logoutAuth, () => initialState);
    // .addCase(getFiatPrices.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(getFiatPrices.fulfilled, (state, action) => {
    //   state.status = 'succeeded';
    //   state.data.fiatPrices = action.payload;
    // })
    // .addCase(getFiatPrices.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.error.message;
    // });
    //   .addCase(getMasterCardData.pending, (state) => {
    //     state.status = 'loading';
    //   })
    //   .addCase(getMasterCardData.fulfilled, (state, action) => {
    //     const newCards = Array.isArray(action.payload.data?.data)
    //       ? action.payload.data.data.filter(
    //           (newCard) => !state.data.masterCard.some((existing) => existing.id === newCard.id)
    //         )
    //       : [];
    //     console.log('Pushing MasterCard data:', newCards); // Debug log
    //     state.data.masterCard.push(...newCards);
    //   })
    //   .addCase(getMasterCardData.rejected, (state, action) => {
    //     state.status = 'failed';
    //     state.error = action.error.message;
    //   });
    // .addCase(createCryptoWallet.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(createCryptoWallet.fulfilled, (state, action) => {
    //   const newWallet = Array.isArray(action.payload.wallet)
    //     ? action.payload.wallet.filter(
    //         (newCard) => !state.data.masterCard.some((existing) => existing.id === newCard.id)
    //       )
    //     : [];       
    //   state.data.cryptoWallets.push(...newWallet);
    // })
    // .addCase(createCryptoWallet.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.error.message;
    // });
  },
});

// export const { updateTicketStatus } = transactionSlice.actions;
export default counterpartySlice.reducer;